import { ReactNode } from "react";
import { MenuProps } from "@mui/material";
import { create } from "zustand";

export interface OpenMenuPayload extends Partial<Omit<MenuProps, "content">> {
  content: ReactNode;
  margin?: string | number;
  width?: string | number;
  minWidth?: string | number;
  maxWidth?: string | number;
  height?: string | number;
  minHeight?: string | number;
  maxHeight?: string | number;
}

export interface MenuStore extends OpenMenuPayload {
  actions: {
    openMenu: (payload: OpenMenuPayload) => void;
    closeMenu: () => void;
  };
}

const initialState: Omit<MenuStore, "actions"> = {
  anchorEl: null,
  content: null,
  margin: 0,
  width: "initial",
  minWidth: "initial",
  maxWidth: "initial",
  height: "initial",
  minHeight: "initial",
  maxHeight: "initial",
};

export const useMenuStore = create<MenuStore>((set, get) => ({
  ...initialState,

  actions: {
    openMenu: (payload) => {
      set(
        {
          ...initialState,
          ...payload,
          actions: get().actions,
        },
        true
      );
    },
    closeMenu: () => {
      set({
        anchorEl: null,
        anchorPosition: undefined,
      });
    },
  },
}));
